import { ApplicationView } from '@aha-app/mvc';
import React from 'react';
import Modal, { ModalHeader } from '../utils/Modal';
import styles from '../styles.module.css';
import type { WhiteboardIntegration } from '../shared-types';

interface ExternalAuthModalProps {
  promptType: 'importModal' | 'exportModal';
  mode: 'connect' | 'reconnect';
  service: WhiteboardIntegration;
  onClose: () => void;
  onConfirm: () => void;
}
const ExternalAuthModal = ({
  promptType,
  mode,
  service,
  onClose,
  onConfirm,
}: ExternalAuthModalProps) => {
  return (
    <Modal onClose={onClose}>
      <div className={styles.externalAuthModal}>
        <ModalHeader
          onClose={onClose}
          modalTitle={
            promptType === 'exportModal'
              ? `Create ${service.getRecordTitle()}`
              : `Import from ${service.title}`
          }
        />

        <aha-modal-body>
          {mode === 'connect' ? (
            promptType === 'exportModal' ? (
              <>
                Please connect to {service.title} to create{' '}
                {service.getRecordTitle(true, false)}.
              </>
            ) : (
              <>
                You pasted a {service.getRecordTitle()}. Would you like to
                import {service.getRecordTitle(false, false)} details from{' '}
                {service.title}?
              </>
            )
          ) : (
            <>
              Your {service.title} connection expired. Would you like to
              reconnect?
            </>
          )}
        </aha-modal-body>

        <aha-modal-footer>
          <aha-button kind='secondary' type='button' onClick={onClose}>
            {mode === 'connect' ? 'Cancel' : 'Not now'}
          </aha-button>

          <aha-button kind='primary' type='button' onClick={onConfirm}>
            {mode === 'connect' ? `Connect to ${service.title}` : 'Reconnect'}
          </aha-button>
        </aha-modal-footer>
      </div>
    </Modal>
  );
};

export default ApplicationView(ExternalAuthModal);
